import Phaser from 'phaser';

function tapTiltDegrees(clientX: number, cx: number) {
  let nx = (clientX - cx) / 150;
  if (nx > 1) nx = 1;
  if (nx < -1) nx = -1;
  if (Math.abs(nx) < 0.1) {
    nx = (Math.random() > 0.5 ? 1 : -1) * 0.2;
  }
  return -nx * 6.5;
}

/** Brief tint flash when the crack frame advances (matches DOM brightness filter). */
export function flashGeodeCrack(scene: Phaser.Scene, sprite: Phaser.GameObjects.Image) {
  if (!sprite.active) return;
  sprite.setTint(0xffffff);
  scene.time.delayedCall(80, () => {
    if (sprite.active) sprite.clearTint();
  });
}

export function playGeodeHitReaction(
  scene: Phaser.Scene,
  opts: {
    wiggle: Phaser.GameObjects.Container;
    squash: Phaser.GameObjects.Container;
    cx: number;
    clientX: number;
    /** When true, skip — respawn tweens must not be killed. */
    respawning?: boolean;
  },
) {
  const { wiggle, squash, cx, clientX, respawning = false } = opts;
  if (!wiggle || !squash || respawning) return;

  const angle = tapTiltDegrees(clientX ?? cx, cx);
  const pulseMs = 55;

  scene.tweens.killTweensOf(wiggle);
  scene.tweens.killTweensOf(squash);
  wiggle.setAngle(angle * 0.55);
  squash.setScale(0.94, 1.07);

  scene.tweens.add({
    targets: squash,
    scaleX: 1,
    scaleY: 1,
    duration: pulseMs,
    ease: 'Quad.easeOut',
  });
  scene.tweens.add({
    targets: wiggle,
    angle: 0,
    duration: pulseMs + 20,
    ease: 'Sine.easeOut',
  });
}
